// extracted by mini-css-extract-plugin
export default {"search":"NavSearch_search__bt7ZF","icon":"NavSearch_icon__Vkn9I"};